<template>
  <!-- <pre v-if="responseData">  test data :: {{ responseData.data.lampu_jalan }}</pre>  -->
  <Background v-if="lampuJalan && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/LAMPU JALAN.png"
        alt="LAMPU JALAN"
        class="pbt-image"
      >

      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <h2>BILANGAN LAMPU JALAN</h2>

      <div class="lampu">

        <div class="lampu-container">
          <img
            src="@/assets/lampu/led.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="overlay-text">
            <h3>BILANGAN LAMPU JALAN JENIS (LED)</h3>
            <p class="number">
              {{ numberWithCommas(lampuJalan.bilangan_lampu_jalan_led) ?? 0 }}
            </p>
          </div>
        </div>


        <div class="lampu-container">
          <img
            src="@/assets/lampu/son.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="overlay-text">
            <h3>BILANGAN LAMPU JALAN JENIS (SON)</h3>
            <p class="number">
              {{ numberWithCommas(lampuJalan.bilangan_lampu_jalan_biasa) ?? 0}}
            </p>
          </div>
        </div>
      </div>
      <Update />
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from '@/components/background/background.vue'
import Menu from '@/components/menu-items/utama-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'



definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()




const lampuJalan = ref({
  lampuJalan: {
    // eslint-disable-next-line camelcase
    bilangan_lampu_jalan_biasa: 0,
    // eslint-disable-next-line camelcase
    bilangan_lampu_jalan_led: 0,
  },

})

const responseData = ref(null)


async function  loadDataFromApiLampu(){
  try {
    const response = await httpGet('kejuruteraan-kesihatan-umum/lampu-jalan')


    responseData.value = response
    lampuJalan.value = response.data.keseluruhan

   
    lampuJalan.value.lampuJalan = {
      // eslint-disable-next-line camelcase
      bilangan_lampu_jalan_biasa: lampuJalan.value ? this.numberWithCommas(lampuJalan.value.bilangan_lampu_jalan_biasa) : 0,
      // eslint-disable-next-line camelcase
      bilangan_lampu_jalan_led: lampuJalan.value ? this.numberWithCommas(lampuJalan.value.bilangan_lampu_jalan_led) : 0,
    }


  } catch (err) {
    console.error('loadDataFromApiLampu failed:', err)
  } 
}



onMounted(() => {
  loadDataFromApiLampu()
})
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px; 
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%;
  height: auto;
}

.line-under-image {
  width: 70%; 
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 20px; 
  text-align: left; 
  width: 100%;
}

.lampu {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.lampu-container {
  position: relative;
  width: 48%; 
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 20px 25px 4px rgba(0, 0, 0, 0.25);
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}


.overlay-text {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  text-align: center;
  color: white;
  padding: 10px;
}

.overlay-text h3 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: black;
}

.number {
  font-size: 54px;
  font-weight: 600;
  color: #a80000;
}


@media (max-width: 768px) {
  .lampu-container {
    width: 100%;
    margin-bottom: 20px;
  }

  .overlay-text h3 {
    font-size: 16px;
  }

  .number {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .lampu {
    flex-direction: column;
    align-items: center;
  }

  .lampu-container {
    width: 100%;
  }

  .overlay-text h3 {
    font-size: 1rem;
  }

  .number {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.2rem;
  }

  .overlay-text h3 {
    font-size: 0.9rem;
  }

  .number {
    font-size: 1.2rem;
  }
}
</style>
